export default [
  {
    path: "importacao/leiautes",
    component: () => import("./LeiautesBmm.vue"),
    meta: { middleware: "auth", controller: "ImportacaoController" },
  },
  {
    path: "importacao/",
    component: require("./Read").default,
    meta: { middleware: "auth", controller: "ImportacaoController" },
  },
  // {
  //   path: "importacao/upload/caixa",
  //   component: require("./UploadCaixa").default,
  //   meta: { middleware: "auth", controller: "ImportacaoController" },
  // },
  {
    path: "importacao/:id",
    component: () => import("./HistoricDetail.vue"),
    meta: { middleware: "auth", controller: "ImportacaoController" },
  },
  // {
  //   path: "importacao/historico",
  //   component: require("./Historic").default,
  //   meta: { middleware: "auth", controller: "ImportacaoController" },
  // },
];
